__turbopack_context__.v({
  "block-img": "D_iBoa_block-img",
  "body": "D_iBoa_body",
  "collapse-button": "D_iBoa_collapse-button",
  "content": "D_iBoa_content",
  "open-quote": "D_iBoa_open-quote",
  "section": "D_iBoa_section",
  "small-body": "D_iBoa_small-body",
  "title": "D_iBoa_title",
});
